import { codeGeneretor, keepObjectProperties } from 'app/utils';
import { /* PAD_TYPE, */ PAD_CARD_TYPES, PAD_ALTERATION_TYPE } from 'app/config/pad';
// import { PRESCRIPTION_TYPE } from 'app/config/padCreator';
// import { FREQUENCY } from 'app/config/frequency_type';
// import { TYPE } from 'app/config/prescription_content';

// import { isNull } from 'lodash';
// import _ from 'lodash';
// import { PAD_VISIT_TYPE } from 'app/config/padVisits';

// const { ALTERATION } = PAD_TYPE;
// const { PERFECT_WAVE_PHASE_I_ALTERATION } = PAD_TYPE;
const { CREATION, ALTERATION, SUSPENSION } = PAD_ALTERATION_TYPE;

const TEMPLATE_NAME = 'PAD_CREATOR';

const STATUS = {
  ACTIVE: 1,
  INACTIVE: 0
};

function buildPadVisit(padVisit) {
  this._padVisit = padVisit;

  this.addPadVisitCode = function (code) {
    this._padVisit.code = code;

    return this;
  };

  this.addPadVisitType = function (padVisitType) {
    this._padVisit.padVisitType = padVisitType;

    return this;
  };

  this.addPadVisitAlterId = function (padVisitAlterId) {
    this._padVisit.padVisitAlterId = padVisitAlterId;

    return this;
  };

  this.addStatus = function (status) {
    this._padVisit.status = status;

    return this;
  };

  this.setUpdateStatus = function () {
    this._padVisit.itHasBeenUpdated = true;

    return this;
  };

  this.suspendPadVisit = function (id) {
    this.addPadVisitType(SUSPENSION);
    this.addPadVisitAlterId(id);
    this.addStatus(STATUS.INACTIVE);

    return this;
  };

  this.unsuspendPadVisit = function () {
    this.addPadVisitType(CREATION);
    this.addPadVisitAlterId(null);
    this.addStatus(STATUS.ACTIVE);

    return this;
  };

  // this.initialize = function () {
  //   this._padVisit = this.cleanPadVisit();
  //   this.addPadVisitCode();
  //   this.addPadVisitType(CREATION);

  //   return this._padVisit;
  // };

  this.addPadCardType = function (padCardType) {
    this._padVisit.padCardType = padCardType;

    return this;
  };

  this.getPadVisit = function () {
    return this._padVisit;
  };

  this.setPadVisit = function (padVisit) {
    this._padVisit = padVisit;

    return this;
  };

  this.cleanPadVisit = function (callback) {
    const { frequency, visitationType, profession, responsible } = this._padVisit;

    this._padVisit.frequency = callback(frequency, ['id', 'name']);
    this._padVisit.visitationType = callback(visitationType, ['id', 'name']);
    this._padVisit.profession = callback(profession, ['id', 'name']);
    this._padVisit.responsible = callback(responsible, ['id', 'name']);

    // delete this._padVisit.id;  // keep id because it's a reference to suspend
    delete this._padVisit.code;
    delete this._padVisit.padVisitType;
    delete this._padVisit.padVisitAlterId;

    delete this._padVisit.pad;
    delete this._padVisit.padId;

    delete this._padVisit.prescription;
    delete this._padVisit.padVisitAlter;
    delete this._padVisit.preferedShift;
    delete this._padVisit.preferedWeekDays;

    delete this._padVisit.created;
    delete this._padVisit.updated;

    this._padVisit.padVisitAlterId = null;

    return this;
  };
}

function buildPadVisits(padVisits, buildPadVisit) {
  this._padVisits = padVisits;

  this.suspend = function (padVisit) {
    this._padVisits = this._padVisits.map(pVisit => {
      if (pVisit.id === padVisit.id) {
        return buildPadVisit.setPadVisit(padVisit).suspendPadVisit(padVisit.id).getPadVisit();
      }
      return pVisit;
    });

    return this;
  };

  this.unsuspend = function (padVisit) {
    this._padVisits = this._padVisits.map(pVisit => {
      if (pVisit.id === padVisit.id) {
        return buildPadVisit.setPadVisit(padVisit).unsuspendPadVisit().getPadVisit();
      }
      return pVisit;
    });

    return this;
  };

  this.getPadVisits = function () {
    return this._padVisits;
  };
}

// function buildPadPrescription(padPrescription) {
//   this._convertInputFieldsToString = function (padPrescription) {
//     let cPadPrescription = {};
//     const inputFields = [
//       'description',
//       'frequencyAmount',
//       'totalAmount',
//       'dose',
//       'diluentDose',
//       'period'
//     ];

//     // eslint-disable-next-line no-unused-vars
//     for (const key in padPrescription) {
//       const value = padPrescription[key];
//       const isInputField = inputFields.includes(`${key}`);

//       cPadPrescription[key] = isInputField ? _.toString(value) : value;
//     }

//     return cPadPrescription;
//   };

//   this._padPrescription = this._convertInputFieldsToString(padPrescription);

//   this.addPadPrescriptionCode = function (code) {
//     this._padPrescription.code = code;

//     return this;
//   };

//   this.addPadPrescriptionType = function (type) {
//     this._padPrescription.type = type;
//     return this;
//   };
//   this.addStatus = function (status) {
//     this._padPrescription.status = status;
//     return this;
//   };

//   this.addPadCardType = function (padCardType) {
//     this._padPrescription.padCardType = padCardType;

//     return this;
//   };

//   this.getType = function () {
//     const { EVALUATIONS, DIET, MEDS, PROCEDURES, NANDAPROCEDURE } = PRESCRIPTION_TYPE;

//     let prescriptionType = null;

//     if (this._padPrescription.dietId) {
//       prescriptionType = DIET;
//     }
//     if (this._padPrescription.medicamentId) {
//       prescriptionType = MEDS;
//     }
//     if (this._padPrescription.procedureId) {
//       prescriptionType = PROCEDURES;
//     }
//     if (this._padPrescription.NANDAProcedureId) {
//       prescriptionType = NANDAPROCEDURE;
//     }
//     if (this._padPrescription.evaluationTypeId) {
//       prescriptionType = EVALUATIONS;
//     }

//     return prescriptionType;
//   };

//   this.getFrequency = function () {
//     const frequencyInMinutes = this._padPrescription.frequency;

//     if (!frequencyInMinutes) return null;

//     const months = frequencyInMinutes % 43800;
//     const biweeks = frequencyInMinutes % 21600;
//     const weeks = frequencyInMinutes % 10080;
//     const days = frequencyInMinutes % 1440;
//     const hours = frequencyInMinutes % 60;

//     if (months === 0) {
//       const frequencyAmount = frequencyInMinutes / 43800;
//       const frequencyId = FREQUENCY.MONTH_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (biweeks === 0) {
//       const frequencyAmount = frequencyInMinutes / 21600;
//       const frequencyId = FREQUENCY.BIWEEK_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (weeks === 0) {
//       const frequencyAmount = frequencyInMinutes / 10080;
//       const frequencyId = FREQUENCY.WEEK_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (days === 0) {
//       const frequencyAmount = frequencyInMinutes / 1440;
//       const frequencyId = FREQUENCY.DAY_ID;

//       return { frequencyAmount, frequencyId };
//     }
//     if (hours === 0) {
//       const frequencyAmount = frequencyInMinutes / 60;
//       const frequencyId = FREQUENCY.HOUR_ID;

//       return { frequencyAmount, frequencyId };
//     }

//     const frequencyAmount = frequencyInMinutes / 60;
//     const frequencyId = FREQUENCY.HOUR_ID;

//     return { frequencyAmount, frequencyId };
//   };

//   this.getPeriod = function () {
//     const periodInDays = this._padPrescription.period;

//     if (!periodInDays) return null;

//     const months = periodInDays % 30;
//     const biweeks = periodInDays % 15;
//     const weeks = periodInDays % 7;
//     const days = periodInDays % 1;

//     if (months === 0) {
//       const periodAmount = periodInDays / 30;
//       const periodFrequencyId = FREQUENCY.MONTH_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//     if (biweeks === 0) {
//       const periodAmount = periodInDays / 15;
//       const periodFrequencyId = FREQUENCY.BIWEEK_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//     if (weeks === 0) {
//       const periodAmount = periodInDays / 7;
//       const periodFrequencyId = FREQUENCY.WEEK_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//     if (days === 0) {
//       const periodAmount = periodInDays / 1;
//       const periodFrequencyId = FREQUENCY.DAY_ID;

//       return { periodAmount, periodFrequencyId };
//     }
//   };

//   this.addFrequency = function (frequency) {
//     if (!frequency) {
//       this._padPrescription.frequencyAmount = null;
//       this._padPrescription.frequencyId = null;
//       return this;
//     }

//     const { frequencyAmount, frequencyId } = frequency;

//     this._padPrescription.frequencyAmount = _.toString(frequencyAmount);
//     this._padPrescription.frequencyId = frequencyId;

//     return this;
//   };

//   // this.addPeriod = function (period) {
//   //   if (!period) return this;

//   //   const { periodAmount, periodFrequencyId } = period;

//   //   this._padPrescription.periodAmount = periodAmount;
//   //   this._padPrescription.periodFrequencyId = periodFrequencyId;

//   //   return this;
//   // };

//   this.addPrescriptionType = function (prescriptionType) {
//     this._padPrescription.prescriptionType = prescriptionType;

//     return this;
//   };

//   this.getPadPrescription = function () {
//     return this._padPrescription;
//   };

//   this.cleanPadPrescription = function (callback) {
//     const {
//       diet,
//       medicament,
//       administrationRoute,
//       diluent,
//       nandaProcedure,
//       procedure,
//       evaluationType
//     } = this._padPrescription;

//     this._padPrescription.diet = callback(diet, ['id', 'name']);
//     this._padPrescription.diluent = callback(diluent, ['id', 'name']);
//     this._padPrescription.procedure = callback(procedure, ['id', 'name']);
//     this._padPrescription.medicament = callback(medicament, ['id', 'name']);
//     this._padPrescription.nandaProcedure = callback(nandaProcedure, ['id', 'name']);
//     this._padPrescription.evaluationType = callback(evaluationType, ['id', 'name']);
//     this._padPrescription.administrationRoute = callback(administrationRoute, ['id', 'name']);

//     // delete this._padPrescription.id;
//     delete this._padPrescription.code;

//     delete this._padPrescription.pad;
//     delete this._padPrescription.padId;

//     delete this._padPrescription.padVisits;
//     delete this._padPrescription.professional;

//     delete this._padPrescription.created;
//     delete this._padPrescription.updated;

//     return this;
//   };
// }

function buildPadDiagnostic(padDiagnostic) {
  this._padDiagnostic = padDiagnostic;

  this.addPadDiagnosticCode = function (code) {
    this._padDiagnostic.code = code;

    return this;
  };

  this.setUpdateStatus = function () {
    this._padDiagnostic.itHasBeenUpdated = true;

    return this;
  };

  this.addPadDiagnosticAlterId = function (padDiagnosticAlterId) {
    this._padDiagnostic.padDiagnosticAlterId = padDiagnosticAlterId;

    return this;
  };

  this.addPadDiagnosticType = function (type) {
    this._padDiagnostic.padDiagnosticType = type;

    return this;
  };

  this.suspendPadDiagnostic = function (id) {
    this.addPadDiagnosticType(SUSPENSION);
    this.addPadDiagnosticAlterId(id);
    this.addStatus(STATUS.INACTIVE);

    return this;
  };

  this.unsuspendPadDiagnostic = function () {
    this.addPadDiagnosticType(CREATION);
    this.addPadDiagnosticAlterId(null);
    this.addStatus(STATUS.ACTIVE);

    return this;
  };

  this.setPadDiagnostic = function (padDiagnostic) {
    this._padDiagnostic = padDiagnostic;

    return this;
  };

  this.addPadDiagnosticType = function (padDiagnosticType) {
    this._padDiagnostic.padDiagnosticType = padDiagnosticType;

    return this;
  };

  this.addPadCardType = function (padCardType) {
    this._padDiagnostic.padCardType = padCardType;

    return this;
  };

  this.addStatus = function (status) {
    this._padDiagnostic.status = status;
    return this;
  };
  this.cleanPadDiagnostic = function (/*callback*/) {
    return this;
  };
  this.getPadDiagnostic = function () {
    return this._padDiagnostic;
  };
}

function buildPadDiagnostics(padDiagnostics, buildPadDiagnostic) {
  this._padDiagnostics = padDiagnostics;

  this.suspend = function (padDiagnostic) {
    this._padDiagnostics = this._padDiagnostics.map(pDiagnostic => {
      if (pDiagnostic.id === padDiagnostic.id) {
        return buildPadDiagnostic
          .setPadDiagnostic(padDiagnostic)
          .suspendPadDiagnostic(padDiagnostic.id)
          .getPadDiagnostic();
      }
      return pDiagnostic;
    });

    return this;
  };

  this.unsuspend = function (padDiagnostic) {
    this._padDiagnostics = this._padDiagnostics.map(pDiagnostic => {
      if (pDiagnostic.id === padDiagnostic.id) {
        return buildPadDiagnostic
          .setPadDiagnostic(pDiagnostic)
          .unsuspendPadDiagnostic()
          .getPadDiagnostic();
      }
      return pDiagnostic;
    });

    return this;
  };

  this.getPadDiagnostics = function () {
    return this._padDiagnostics;
  };
}

const preparePadVisits = (padVisits, padVisitType) => {
  return padVisits.map(padVisit => {
    const code = codeGeneretor();

    return new buildPadVisit(padVisit)
      .cleanPadVisit(keepObjectProperties)
      .addPadVisitType(padVisitType)
      .addPadCardType(PAD_CARD_TYPES.VISIT)
      .addPadVisitCode(code)
      .addStatus(1)
      .getPadVisit();
  });
};
// const preparePadPrescription = (padPrescriptions, padType) => {
//   return padPrescriptions.map(padPrescription => {
//     const prescriptionType = new buildPadPrescription(padPrescription).getType();
//     const frequency = new buildPadPrescription(padPrescription).getFrequency();

//     let code;

//     if ([PAD_TYPE.RENOVATION, PAD_TYPE.PERFECT_WAVE_PHASE_I_RENOVATION].includes(padType)) {
//       code = codeGeneretor();
//     } else {
//       code = padPrescription.code;
//     }

//     return new buildPadPrescription(padPrescription)
//       .cleanPadPrescription(keepObjectProperties)
//       .addPadCardType(PAD_CARD_TYPES.PRESCRIPTION)
//       .addPrescriptionType(prescriptionType)
//       .addFrequency(frequency)
//       .addPadPrescriptionType(TYPE.SUSTEINED)
//       .addPadPrescriptionCode(code)
//       .addStatus(1)
//       .getPadPrescription();
//   });
// };
const preparePadDiagnostic = padDiagnostics => {
  return padDiagnostics.map(padDiagnostic => {
    // const code = codeGeneretor();

    return (
      new buildPadDiagnostic(padDiagnostic)
        .cleanPadDiagnostic(keepObjectProperties)
        .addPadCardType(PAD_CARD_TYPES.DIAGNOSTIC)
        //.addPrescriptionType(prescriptionType)
        //.addFrequency(frequency)
        // .addPeriod(period)
        .setPadDiagnostic(padDiagnostic)
        // .addPadDiagnosticCode(code)
        .addStatus(1)
        .getPadDiagnostic()
    );
  });
};

const initialState = () => ({
  loading: false,
  isPadDefined: false,
  pad: {},
  errors: [],
  padVisits: {
    loadedData: [],
    screenData: [],
    submitData: []
  },
  // padPrescription: {
  //   loadedData: [],
  //   screenData: [],
  //   submitData: []
  // },
  padDiagnostic: {
    loadedData: [],
    screenData: [],
    submitData: []
  },
  padDiagnosticCid: {
    loadedData: [],
    screenData: [],
    submitData: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      const { padVisits, /*  padPrescription, */ padDiagnostic, padDiagnosticCid } = newData;

      // const { PADType } = state.pad;
      // const { ALTERATION, PERFECT_WAVE_PHASE_I_ALTERATION } = PAD_TYPE;
      // const isPadAlteration = [ALTERATION, PERFECT_WAVE_PHASE_I_ALTERATION].includes(PADType);

      // const padPrescriptionPrepared = preparePadPrescription(padPrescription, PADType);

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          loadedData: padVisits,
          screenData: preparePadVisits(padVisits, CREATION)
          // submitData: isPadAlteration ? [] : preparePadVisits(padVisits, CREATION)
        },
        // padPrescription: {
        //   ...state.padPrescription,
        //   loadedData: padPrescriptionPrepared,
        //   screenData: padPrescriptionPrepared,
        //   submitData: padPrescriptionPrepared
        // },
        padDiagnostic: {
          ...state.padDiagnostic,
          loadedData: padDiagnostic,
          screenData: preparePadDiagnostic(padDiagnostic),
          submitData: preparePadDiagnostic(padDiagnostic)
        },
        padDiagnosticCid: {
          ...state.padDiagnosticCid,
          loadedData: padDiagnosticCid,
          screenData: padDiagnosticCid,
          submitData: padDiagnosticCid
        }
      };
    }

    case `${TEMPLATE_NAME}_VALIDATE_DEFINE_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_VALIDATE_DEFINE_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_VALIDATE_DEFINE_FULFILLED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_SAVE_PAD`: {
      const newData = action.payload;
      const pad = newData.data;

      return {
        ...state,
        loading: false,
        pad
      };
    }

    /*
     *  PAD VISIT
     */

    case `${TEMPLATE_NAME}_SAVE_PAD_VISIT`: {
      const newData = action.payload;
      const padVisit = newData.data;

      const { screenData, submitData } = state.padVisits;

      const code = codeGeneretor();

      const addPadVisit = new buildPadVisit(padVisit)
        .addPadVisitType(CREATION)
        .addPadVisitCode(code)
        .addStatus(1)
        .addPadCardType(PAD_CARD_TYPES.VISIT)
        .getPadVisit();

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData: [...screenData, addPadVisit],
          submitData: [...submitData, addPadVisit]
        }
      };
    }

    case `${TEMPLATE_NAME}_UPDATE_PAD_VISIT`: {
      const newData = action.payload;
      const padVisit = new buildPadVisit({ ...newData.data }).setUpdateStatus().getPadVisit();

      const screenData = [...state.padVisits.screenData];
      const submitData = [...state.padVisits.submitData];

      const indexScreen = screenData.findIndex(pVisit => pVisit.code === padVisit.code);
      screenData.splice(indexScreen, 1, padVisit);

      const indexSubmit = submitData.findIndex(pVisit => pVisit.code === padVisit.code);
      submitData.splice(indexSubmit, 1, padVisit);

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_CHANGE_PAD_VISIT`: {
      const newData = action.payload;
      const padVisit = newData.data;

      const cPadVisit = { ...padVisit, itHasBeenUpdated: true };

      cPadVisit.padVisitAlterId = padVisit.id;
      cPadVisit.padVisitType = ALTERATION;

      const screenData = [...state.padVisits.screenData];
      const submitData = [...state.padVisits.submitData];

      const indexScreen = screenData.findIndex(pVisit => pVisit.code === padVisit.code);
      screenData.splice(indexScreen, 1, cPadVisit);

      let indexSubmit = submitData.findIndex(pVisit => pVisit.code === padVisit.code);
      const somethingWasFound = indexSubmit !== -1;
      indexSubmit = somethingWasFound ? indexSubmit : submitData.length;
      submitData.splice(indexSubmit, 1, cPadVisit);

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_REMOVE_PAD_VISIT`: {
      const newData = action.payload;
      const padVisit = newData.data;

      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const screenData = pScreenData.filter(pVisit => pVisit.code !== padVisit.code);
      const submitData = pSubmitData.filter(pVisit => pVisit.code !== padVisit.code);

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_SUSPEND_PAD_VISIT`: {
      const newData = action.payload;
      const padVisit = newData.data;

      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const screenData = new buildPadVisits(pScreenData, new buildPadVisit())
        .suspend(padVisit)
        .getPadVisits();

      const pVisit = screenData.find(pVisit => pVisit.code === padVisit.code);

      const submitData = [...pSubmitData, pVisit];
      // const submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
      //   .suspend(padVisit)
      //   .getPadVisits();

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_UNSUSPEND_PAD_VISIT`: {
      const newData = action.payload;
      const padVisit = newData.data;

      const pScreenData = [...state.padVisits.screenData];
      const pSubmitData = [...state.padVisits.submitData];

      const screenData = new buildPadVisits(pScreenData, new buildPadVisit())
        .unsuspend(padVisit)
        .getPadVisits();

      const submitData = pSubmitData.filter(pVisit => pVisit.code !== padVisit.code);

      // const submitData = new buildPadVisits(pSubmitData, new buildPadVisit())
      //   .unsuspend(padVisit)
      //   .getPadVisits();

      return {
        ...state,
        loading: false,
        padVisits: {
          ...state.padVisits,
          screenData,
          submitData
        }
      };
    }

    /*
     *  PAD PRESCRIPTION
     */

    // case `${TEMPLATE_NAME}_ADD_PAD_PRESCRIPTION`: {
    //   const newData = action.payload;
    //   const padPrescription = newData.data;

    //   const { screenData, submitData } = state.padPrescription;

    //   const code = codeGeneretor();

    //   const addPadPrescription = new buildPadPrescription(padPrescription)
    //     .addPadPrescriptionCode(code)
    //     .addStatus(STATUS.ACTIVE)
    //     .getPadPrescription();

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData: [...screenData, addPadPrescription],
    //       submitData: [...submitData, addPadPrescription]
    //     }
    //   };
    // }

    // case `${TEMPLATE_NAME}_EDIT_PAD_PRESCRIPTION`: {
    //   const newData = action.payload;
    //   const padPrescription = new buildPadPrescription({ ...newData.data })
    //     .addStatus(STATUS.ACTIVE)
    //     .getPadPrescription();

    //   const screenData = [...state.padPrescription.screenData];
    //   const submitData = [...state.padPrescription.submitData];

    //   const indexScreen = screenData.findIndex(
    //     pPrescription => pPrescription.code === padPrescription.code
    //   );
    //   screenData.splice(indexScreen, 1, padPrescription);

    //   const indexSubmit = submitData.findIndex(
    //     pPrescription => pPrescription.code === padPrescription.code
    //   );
    //   submitData.splice(indexSubmit, 1, padPrescription);

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData,
    //       submitData
    //     }
    //   };
    // }

    // case `${TEMPLATE_NAME}_REMOVE_PAD_PRESCRIPTION`: {
    //   const newData = action.payload;
    //   const padPrescription = newData.data;

    //   const pScreenData = [...state.padPrescription.screenData];
    //   const pSubmitData = [...state.padPrescription.submitData];

    //   const screenData = pScreenData.filter(
    //     pPrescription => pPrescription.code !== padPrescription.code
    //   );
    //   const submitData = pSubmitData.filter(
    //     pPrescription => pPrescription.code !== padPrescription.code
    //   );

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData,
    //       submitData
    //     }
    //   };
    // }

    // case `${TEMPLATE_NAME}_CHANGE_STATUS_PAD_PRESCRIPTION`: {
    //   const padPrescription = action.payload.data;

    //   const screenData = _.cloneDeep(state.padPrescription.screenData);
    //   const submitData = _.cloneDeep(state.padPrescription.submitData);

    //   const screenDataIndex = screenData.findIndex(
    //     pPrescription => pPrescription.code === padPrescription.code
    //   );
    //   const submitDataIndex = submitData.findIndex(
    //     pPrescription => pPrescription.code === padPrescription.code
    //   );

    //   const status = screenData[screenDataIndex].status ? 0 : 1;

    //   screenData[screenDataIndex].status = status;

    //   submitData[submitDataIndex].status = status;

    //   return {
    //     ...state,
    //     loading: false,
    //     padPrescription: {
    //       ...state.padPrescription,
    //       screenData,
    //       submitData
    //     }
    //   };
    // }

    /*
     *  PAD DIAGNOSTIC
     */

    case `${TEMPLATE_NAME}_SAVE_PAD_DIAGNOSTIC`: {
      const newData = action.payload;
      const padDiagnostic = newData.data;

      const { screenData, submitData } = state.padDiagnostic;
      const code = codeGeneretor();

      const addPadDiagnostic = new buildPadDiagnostic(padDiagnostic)
        .addPadDiagnosticCode(code)
        .addStatus(1)
        .addPadDiagnosticType(CREATION)
        .addPadCardType(PAD_CARD_TYPES.DIAGNOSTIC)
        .getPadDiagnostic();
      return {
        ...state,
        loading: false,
        padDiagnostic: {
          ...state.padDiagnostic,
          screenData: [...screenData, addPadDiagnostic],
          submitData: [...submitData, addPadDiagnostic]
        }
      };
    }

    // case `${TEMPLATE_NAME}_SAVE_PAD_DIAGNOSTIC`: {
    //   const newData = action.payload;
    //   const padDiagnostic = newData.data;

    //   return {
    //     ...state,
    //     loading: false,
    //     padDiagnostic
    //   };
    // }

    // case `${TEMPLATE_NAME}_SAVE_PAD_DIAGNOSTIC_CID`: {
    //   const newData = action.payload;
    //   const padDiagnosticCid = newData.data;

    //   console.log(pad);
    //   const { screenData, submitData } = state.padDiagnosticCid;

    //   const code = codeGeneretor();

    //   const addPadDiagnosticCid = new buildPadDiagnostic(padDiagnosticCid)
    //     .addPadDiagnosticCode(code)
    //     .addStatus(1)
    //     .addPadDiagnosticType(CREATION)
    //     .addPadCardType(PAD_CARD_TYPES.DIAGNOSTIC)
    //     .getPadDiagnostic();

    //   return {
    //     ...state,
    //     loading: false,
    //     padDiagnosticCid: {
    //       ...state.padDiagnosticCid,
    //       screenData: [...screenData, addPadDiagnosticCid],
    //       submitData: [...submitData, addPadDiagnosticCid]
    //     }
    //   };
    // }

    case `${TEMPLATE_NAME}_UPDATE_PAD_DIAGNOSTIC`: {
      const newData = action.payload;
      const padDiagnostic = new buildPadDiagnostic({ ...newData.data })
        .setUpdateStatus()
        .getPadDiagnostic();

      const screenData = [...state.padDiagnostic.screenData];
      const submitData = [...state.padDiagnostic.submitData];

      const indexScreen = screenData.findIndex(
        pDiagnostic => pDiagnostic.code === padDiagnostic.code
      );
      screenData.splice(indexScreen, 1, padDiagnostic);

      const indexSubmit = submitData.findIndex(
        pDiagnostic => pDiagnostic.code === padDiagnostic.code
      );
      submitData.splice(indexSubmit, 1, padDiagnostic);

      return {
        ...state,
        loading: false,
        padDiagnostic: {
          ...state.padDiagnostic,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_REMOVE_PAD_DIAGNOSTIC`: {
      const newData = action.payload;
      const padDiagnostic = newData.data;

      const pScreenData = [...state.padDiagnostic.screenData];
      const pSubmitData = [...state.padDiagnostic.submitData];

      const screenData = pScreenData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);
      const submitData = pSubmitData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);

      return {
        ...state,
        loading: false,
        padDiagnostic: {
          ...state.padDiagnostic,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_SUSPEND_PAD_DIAGNOSTIC`: {
      const newData = action.payload;
      const padDiagnostic = newData.data;

      const pScreenData = [...state.padDiagnosticCid.screenData];
      const pSubmitData = [...state.padDiagnosticCid.submitData];

      const screenData = new buildPadDiagnostics(pScreenData, new buildPadDiagnostic())
        .suspend(padDiagnostic)
        .getPadDiagnostics();

      const pDiagnostic = screenData.find(pDiagnostic => pDiagnostic.code === padDiagnostic.code);

      const submitData = [...pSubmitData, pDiagnostic];

      return {
        ...state,
        loading: false,
        padDiagnosticCid: {
          ...state.padDiagnosticCid,
          screenData,
          submitData
        }
      };
    }

    case `${TEMPLATE_NAME}_UNSUSPEND_PAD_DIAGNOSTIC`: {
      const newData = action.payload;
      const padDiagnostic = newData.data;

      const pScreenData = [...state.padDiagnosticCid.screenData];
      const pSubmitData = [...state.padDiagnosticCid.submitData];

      const screenData = new buildPadDiagnostics(pScreenData, new buildPadDiagnostic())
        .unsuspend(padDiagnostic)
        .getPadDiagnostics();

      const submitData = pSubmitData.filter(pDiagnostic => pDiagnostic.code !== padDiagnostic.code);

      return {
        ...state,
        loading: false,
        padDiagnosticCid: {
          ...state.padDiagnosticCid,
          screenData,
          submitData
        }
      };
    }

    /*
     *
     */

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    case `${TEMPLATE_NAME}_SET_IS_PAD_DEFINED`: {
      const isPadDefined = action.payload;
      return {
        ...state,
        isPadDefined
      };
    }

    default:
      return state;
  }
};

export default reducer;
